import React from "react";

const EmailHTML = ({ name, email, contact, subject, messageBody }) => {
	const html = `
        <!DOCTYPE html>
        <html lang="en">
            <head>
                <meta charset="UTF-8" />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0" />
                <link
                    rel="stylesheet"
                    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.1/css/all.min.css"
                    integrity="sha512-KfkfwYDsLkIlwQp6LFnl8zNdLGxu9YAA1QvwINks4PhcElQSvqcyVLLD9aMhXd13uQjoXtEKNosOWaZqXgel0g=="
                    crossorigin="anonymous"
                    referrerpolicy="no-referrer" />
                <style>
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                        font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
                            Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue",
                            sans-serif;
                    }

                    body {
                        margin: 10px 0;
                    }

                    /* container */
                    .container {
                        width: 50%;
                        margin: 5px auto;
                        padding: 10px;
                        background-color: #eee;
                    }

                    .inner-container {
                        width: 95%;
                        margin: 0 auto;
                        background-color: white;
                    }

                    /* header */
                    #header {
                        padding: 10px;
                    }

                    h1 {
                        font-size: 1.5rem;
                        position: relative;
                        left: 50px;
                    }

                    /* content */
                    #content {
                        margin: 20px 0;
                        padding: 10px 0;
                        text-align: center;
                    }

                    #content p {
                        margin: 5px 0;
                    }

                    /* message body */
                    #message-body-container {
                        width: 70%;
                        margin: 10px auto;
                        padding: 20px;
                        text-align: start;
                    }

                    #message-body-container span {
                        margin: 20px 0 5px 0;
                        display: inline-block;
                        text-align: start;
                    }

                    #message-body {
                        text-align: justify;
                        padding: 10px 0;
                    }

                    /* footer */
                    #footer {
                        position: relative;
                        bottom: 5px;
                    }

                    #footer #social-media-links {
                        margin: 10px auto;
                        text-align: center;
                    }

                    .social-media-link {
                        margin: 0 5px;
                        font-size: 1rem;
                    }

                    #footer p {
                        padding: 2px 5px;
                        text-align: end;
                        font-style: italic;
                        font-size: 0.8rem;
                    }

                    @media only screen and (max-width: 1024px) {
                        .container {
                            width: 100%;
                            margin: 5px auto;
                            padding: 10px 0;
                            background-color: #eee;
                        }

                        .inner-container {
                            width: 90%;
                            margin: 0 auto;
                            background-color: white;
                        }

                        h1 {
                            font-size: 1.5rem;
                            position: relative;
                            left: 10px;
                        }

                        #message-body-container {
                            width: 90%;
                            margin: 5px auto;
                            padding: 5px 0;
                        }
                    }
                </style>
            </head>
            <body>
                <div class="container">
                    <div class="inner-container">
                        <header id="header">
                            <h1>Hello ${name} 👋</h1>
                        </header>

                        <div id="content">
                            <p>Thank you for connecting with me.</p>
                            <p>Let's make something awesome together!</p>

                            <div id="message-body-container">
                                <span>Message details</span>:
                                <div id="message-body">
                                    ${messageBody}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="footer">
                        <div id="social-media-links">
                            <a
                                class="social-media-link"
                                target="_blank"
                                href="https://facebook.com/ivanvielled"
                                ><img
                                    src="https://cdn-icons-png.freepik.com/256/5968/5968764.png?ga=GA1.1.403560512.1723675701&semt=ais_hybrid"
                                    alt=""
                                    height="30px"
                                    width="auto"
                            /></a>
                            <a
                                class="social-media-link"
                                target="_blank"
                                href="https://www.linkedin.com/in/ivanvielle/"
                                ><img
                                    src="https://cdn-icons-png.freepik.com/256/3536/3536505.png?ga=GA1.1.403560512.1723675701&semt=ais_hybrid"
                                    alt=""
                                    height="30px"
                                    width="auto"
                            /></a>
                            <a
                                class="social-media-link"
                                target="_blank"
                                href="https://discord.com/users/alphachino5947"
                                ><img
                                    src="https://cdn-icons-png.freepik.com/256/5968/5968756.png?ga=GA1.1.403560512.1723675701&semt=ais_hybrid"
                                    alt=""
                                    height="30px"
                                    width="auto"
                            /></a>
                            <a
                                class="social-media-link"
                                target="_blank"
                                href="https://www.instagram.com/ivanvielle/"
                                ><img
                                    src="https://cdn-icons-png.freepik.com/256/2504/2504918.png?ga=GA1.1.403560512.1723675701&semt=ais_hybrid"
                                    alt=""
                                    height="30px"
                                    width="auto"
                            /></a>
                        </div>
                        <div>
                            <p>- Ivanvielle B. Dupaya</p>
                            <p>Web Developer</p>
                        </div>
                    </div>
                </div>
            </body>
        </html>
    `;

	return html;
};

export default EmailHTML;
